<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>{{
                        $route.meta.title
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="account-type" v-if="authenticationStatus==-1">
                <h4>请选择一种账号类型</h4>
                <p class="warning">
                    <i class="el-icon-warning"></i
                    >&nbsp;&nbsp;&nbsp;&nbsp;一个账号只能认证一种类型，认证成功后不可修改。请谨慎选择。
                </p>
                <ul class="choose">
                    <li @click="goPersonal()">
                        <dl>
                            <dt>
                                <img src="@/assets/images/gr.png" alt="" />
                            </dt>
                            <dd>
                                <h3>自然人账号</h3>
                                <span>自然人</span>
                            </dd>
                        </dl>
                    </li>
                    <li @click="entChoose">
                        <dl>
                            <dt>
                                <img src="@/assets/images/qy.png" alt="" />
                            </dt>
                            <dd>
                                <h3>法人账号</h3>
                                <span>企业法人、事业法人、政府法人</span>
                            </dd>
                        </dl>
                    </li>
                </ul>
            </div>
            <div class="userInfo" v-else>
                <!-- 新版实名线下授权书申请 -->
                <div class="tip tip_info" v-if="type == 2 && authenticationStatus == 6">
                    <i class="el-icon-warning"></i> 认证信息审核中
                </div>
                <div class="tip tip_err" v-if="type == 2 && authenticationStatus == 8">
                    <i class="el-icon-error"></i> 认证信息已拒绝：{{reason}}
                </div>
                <!-- 老版本线下审核 -->
                <div class="tip tip_info" v-if="type == 2 && authenticationStatus == 3">
                    <i class="el-icon-warning"></i> 基础信息审核中
                </div>
                <div class="tip tip_err" v-if="type == 2 && authenticationStatus == 5">
                    <i class="el-icon-error"></i> 基础信息已拒绝：{{reason}}
                </div>
                <!-- 企业未强实名 -->
                <div class="tip tip_waring" v-if="(type == 2 && authenticationStatus == 4 && sign)">
                    <i class="el-icon-warning"></i> 基础信息认证已完成，如需使用电子签名（壹签）服务，请继续完成强实名认证
                </div>
                <!-- 个人未强实名 -->
                <div class="tip tip_waring" v-if="(type == 1 && [0,1,11].includes(authenticationStatus) && sign)">
                    <i class="el-icon-warning"></i> 如需使用电子签名（壹签）服务，请继续认证
                </div>
                <el-row :gutter="0" type="flex" class="row-item">
                    <el-col :span="5">
                        <p>姓名/企业/单位名称：</p>
                    </el-col>
                    <el-col :span="15" class="name-col">
                        <div class="info-wrap">
                            <div>
                                <p class="infoName">
                                    {{lookName?userInfo.originName : userInfo.name}}
                                    <img src="@/assets/images/vip1.png" alt="" v-if="[-1,3,5].includes(authenticationStatus)" />
                                    <img src="@/assets/images/vip2.png" alt="" v-if="[0,1,2,11].includes(authenticationStatus)" />
                                    <img src="@/assets/images/vip3.png" alt="" v-if="[4,6,8,9].includes(authenticationStatus)" />
                                    <img src="@/assets/images/vip4.png" alt="" v-if="[10,7].includes(authenticationStatus)" />
                                </p>
                                <span @click='hanldEyes(1)'>
                                    <img :src="lookName?eyesOpen:eyesClose" alt="">
                                </span>
                            </div>
                            <p v-if="type == 2 && (authenticationStatus==4 || authenticationStatus==9) && !sign">
                                （已完成基础信息认证）
                            </p>
                        </div>
                    </el-col>
                    <el-col :span="4" class="clear-realName">
                        <p class="clearbtn" v-if="[0,1,2,4,7,8,10,11].includes(authenticationStatus)">
                            <span @click="clearRealName">清除实名</span>
                        </p>
                        <p 
                            v-if="
                                //企业普通企业实名申请中或线下授权申请中
                                (type == 2 && (authenticationStatus == 6 || authenticationStatus == 3))
                            "
                        >
                            <span class="opBtn cancal" @click="look">查看详情</span>
                        </p>
                        <p 
                            v-if="
                                //认证已拒绝
                                (type == 2 && (authenticationStatus == 5 || authenticationStatus ==8))
                            "
                        >
                            <span class="opBtn goon" @click="reopen">重新认证</span>
                        </p>
                        <!-- 个人不是人脸认证的 -->
                        <p v-if="(type == 1 && (authenticationStatus!==2 && sign))">
                            <span class="goon goon2" @click="goOn">继续认证</span>
                        </p>
                        <!-- 企业普通企业实名已通过但未签署授权书 -->
                        <p v-if="(type == 2 && (authenticationStatus==4 || authenticationStatus==9))">
                            <span class="goon goon2" @click="goOn">强实名认证</span>
                        </p>
                    </el-col>
                </el-row>
                <el-row :gutter="0" type="flex" class="row-item">
                    <el-col :span="5"><p>类型：</p></el-col>
                    <el-col :span="17"><p>{{type==2?'法人':'自然人'}}</p></el-col>
                </el-row>
                <el-row :gutter="0" type="flex" class="row-item">
                    <el-col :span="5"><p>认证证件号：</p></el-col>
                    <el-col :span="17" class="name-col">
                        <p v-if="lookCard">{{type==2?userInfo.originUscc : userInfo.originIdCard}}</p>
                        <p v-else>{{type==2?userInfo.uscc : userInfo.idCard}}</p>
                        <span @click='hanldEyes(2)'>
                            <img :src="lookCard?eyesOpen:eyesClose" alt="">
                        </span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="masking" v-if="masking">
            <div class="maskCnt">
                <div class="cntTitle">
                    <h3>法人类型选择</h3>
                    <i class="el-icon-close" @click="masking = false"></i>
                </div>
                <ul class="cntMain">
                    <li :class="activeIndex==1?'active':''" @click="chooseattestation(1)">
                        <dl>
                            <dt>
                                <h4>企业、个体工商户等基础信息认证</h4>
                                <p>自动审核，即时通过</p>
                            </dt>
                            <dd>
                                <img
                                    src="@/assets/images/realName/entico1.jpg"
                                    alt=""
                                />
                            </dd>
                        </dl>
                    </li>
                    <li :class="activeIndex==2?'active':''" @click="chooseattestation(2)" >
                        <dl>
                            <dt>
                                <h4>律师事务所基础信息认证</h4>
                                <p>
                                    人工核验基本信息
                                </p>
                            </dt>
                            <dd>
                                <img
                                    src="@/assets/images/realName/entico2.jpg"
                                    alt=""
                                />
                            </dd>
                        </dl>
                    </li>
                    <li :class="activeIndex==3?'active':''" @click="chooseattestation(3)">
                        <dl>
                            <dt>
                                <h4>
                                    政府、社会团体、事业单位、其他组织等基础信息认证
                                </h4>
                                <p>
                                    人工核验基本信息
                                </p>
                            </dt>
                            <dd>
                                <img
                                    src="@/assets/images/realName/entico3.jpg"
                                    alt=""
                                />
                            </dd>
                        </dl>
                    </li>
                </ul>
                <div class="footer">
                    <p class="guide">
                        非大陆企业、组织请查看<a @click="goTsa">《非大陆企业、组织认证指引》</a>
                    </p>
                    <div class="attention">
                        <h5>注意事项：</h5>
                        <p>
                            <b>1</b>申请基础信息认证时需提交真实有效的认证材料，认证完成后，该账号在平台产生的数据权益归认证主体所有；平台默认申请人（自然人）为认证主体的账号管理人、实际操作责任人，若提交虚假资料擅自开通账号，申请人需承担全部责任；
                        </p>
                        <p>
                            <b>2</b>基础信息认证通过后，如需要使用电子签名等服务，您可在个人中心继续完成强实名认证。
                        </p>
                    </div>
                    <p class="agreement">
                        <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
                        <a :href="realNameAgreement" target="_blank" @click="lookDoc">《实名认证服务协议》</a>
                    </p>
                    <div class="btns" ref="btn">
                        <span :class="checked?'isClick':''" @click="goattestation">开始认证</span>
                    </div>
                </div>
            </div>
        </div>
        <ClearRealName v-if="clearDialog" @closeProcess="clearDialog=false" @reload="init" />
    </el-row>
</template>

<script>
import { identification } from "@http/user_center/userInfo";
import {identificationProtocol} from '@http/user_center/realName'
import ClearRealName from "@/components/RealName/ClearRealName";
export default {
    data() {
        return {
            type: "",
            authenticationStatus: "4",
            reason: "",
            masking: false,
            userInfo:{},
            checked:false,
            activeIndex:'',
            realNameAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/realNameProtocol',
            lookName:false,
            lookCard:false,
            eyesOpen:require('@/assets/images/openEyes.png'),
            eyesClose:require('@/assets/images/closeEyes.png'),
            clearDialog:false,
        };
    },

    components: {ClearRealName},

    computed: {
        channelCodeValue(){
            return this.$store.state.config.channelCodeValue;
        },
        sign(){
            if(this.$getlocalStorage('queryData')?.identifyType==1 || this.$route.query?.identifyType==1 || this.$getlocalStorage('queryData')?.clientId==925220){
                return true
            }else{
                return false
            }
        }
    },

    watch: {
      checked(newVal) {
          if(newVal){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35003,
                },
            });
          }else{
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35004,
                },
            });
          }
      },
    },
    created() {
        this.init();
    },

    mounted() {
        this.$TsaWebTrace.post({
            data: {
                "eventId": 35000,
            },
        });
    },

    methods: {
        init(){
            let that = this;
            zhuge.track('用户中心_进入实名认证', {'渠道': this.channelCodeValue})
            identification({hiddenApproval:true}).then((res) => {
                that.authenticationStatus = res.authenticationStatus;//对应的值看下方注释
                that.type = res.type;
                that.reason = res.reason;
                if(res.type==2){
                    that.userInfo=res.enterprise;
                }else{
                    that.userInfo=res.personal
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        lookDoc(){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35002,
                },
            });
        },
        goPersonal(){
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35001,
                },
            });
            //壹签用户
            // if(this.$getlocalStorage('queryData')?.identifyType==1 || this.$route.query?.identifyType==1 || this.$getlocalStorage('queryData')?.clientId==925220)
            this.$router.push({
                path: "/userCenter/AuthenticationName/Individual",
            });
        },
        chooseattestation(n){
            this.activeIndex=n;
            if(n==1){
                this.$TsaWebTrace.post({
                    data: {
                        "eventId": 35012,
                    },
                });
            }else if(n==2){
                this.$TsaWebTrace.post({
                    data: {
                        "eventId": 35013,
                    },
                });
            }else{
                this.$TsaWebTrace.post({
                    data: {
                        "eventId": 35014,
                    },
                });
            }
            this.$refs.btn.scrollIntoView({behavior: 'smooth'})
        },
        goattestation() {
            if(!this.activeIndex){
                this.$msg("请先选择认证类型");
                return false;
            }
            if(!this.checked){
                this.$msg("请先阅读并勾选协议");
                return false;
            }

            identificationProtocol().then(()=>{
                if(this.activeIndex==1){
                    zhuge.track('用户中心_企业开始认证', {'渠道': this.channelCodeValue},()=> {
                        this.$router.push({path:'/userCenter/realName/enterpriseInfo'})
                        //this.$router.push({path:'/userCenter/Enterapply?gr=true'})
                    })
                }else if(this.activeIndex==2){
                    zhuge.track('用户中心_事务所开始认证', {'渠道': this.channelCodeValue},()=> {
                        this.$router.push({path:'/userCenter/Enterapply?ls=true'})
                    })
                }else{
                    zhuge.track('用户中心_机关开始认证', {'渠道': this.channelCodeValue},()=> {
                        this.$router.push({path:'/userCenter/Enterapply'})
                    })
                }
            }).catch((err) => {
                this.$msg("协议签署服务失败");
            });
            
        },
        entChoose() {
            this.$TsaWebTrace.post({
                data: {
                    "eventId": 35011,
                },
            });
            this.masking = true;
        },
        goOn(){
            if(this.type==2){
                this.$TsaWebTrace.post({
                    data: {
                        "eventId": 35018,
                    },
                });
                if(this.authenticationStatus==4){
                    this.$router.push({
                        path:'/userCenter/realName/enterpriseAuthorize'
                    })
                }else if(this.authenticationStatus==9){
                    this.$router.push({
                        path:'/userCenter/realName/enterpriseSign'
                    })
                }
            }else{
                this.$TsaWebTrace.post({
                    data: {
                        "eventId": 35034,
                    },
                });
                if(this.authenticationStatus!==2){
                    this.$router.push({
                        path:'/userCenter/FaceIdent',
                        query:{
                            identifyType:1,
                        }
                    })
                }
            }
        },
        look(){
            if(this.authenticationStatus == 6){
                this.$router.push({
                    path:'/userCenter/realName/enterpriseResult'
                })
            }else if(this.authenticationStatus == 3){
                this.$router.push({
                    path:'/userCenter/Entercheck'
                })
            }
        },
        reopen(){
            if(this.authenticationStatus == 5){
                this.authenticationStatus=-1;
            }else if(this.authenticationStatus == 8){
                this.$router.push({
                    path:'/userCenter/realName/enterpriseAuthorize'
                })
            }
        },
        hanldEyes(n){
            if(n==1){
                this.lookName=!this.lookName;
            }else{
                this.lookCard=!this.lookCard;
            }
        },
        clearRealName(){
            zhuge.track('用户中心_清除实名', {'渠道': this.channelCodeValue})
            this.clearDialog=true;
        },
        goTsa(){
            window.open(process.env.VUE_APP_TSA+'/baike/18956.html')
        }
    },
};
</script>
<!-- authenticationStatus
/**
    * 未认证.
    */
DEFAULT((byte) -1),

/**
    * 银行四要素认证.
    */
BANK_APPROVE((byte) 0),

/**
    * 手机三要素认证.
    */
PHONE_APPROVE((byte) 1),

/**
    * 人脸识别认证.
    */
FACE_APPROVE((byte) 2),

/**
    * 普通企业实名申请中
    */
ORDINARY_AUDIT((byte) 3),

/**
    * 普通企业实名已通过.
    */
ORDINARY_APPROVE((byte) 4),

/**
    * 普通企业实名已拒绝.
    */
ORDINARY_REJECT((byte) 5),

/**
    * 对公打款申请中.
    */
REMITTANCE_AUDIT((byte) 6),

/**
    * 对公打款实名已完成.
    */
REMITTANCE_APPROVE((byte) 7),

/**
    * 对公打款实名已拒绝.
    */
REMITTANCE_REJECT((byte) 8),

/**
    * 法人认证已通过但未签署授权书.
    */
LEGAL_APPROVE_NOT_SIGNED((byte) 9),

/**
    * 法人认证已通过.
    */
LEGAL_APPROVE((byte) 10); 

/**
    * 老版人脸已通过，没照片.
    */
LEGAL_APPROVE((byte) 11); 


-->



<style src="../../assets/css/content.css" scoped></style>

<style scoped lang="less">
.warning {
    font-size: 14px;
}
.account-type {
    padding-top: 31px;
    width: 930px;
    margin: 0 auto;
    h4 {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        margin-bottom: 20px;
    }
}
.choose {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 30px;
    li {
        width: 420px;
        border: 1px solid #d9d9d9;
        cursor: pointer;
        .ico {
            width: 40px;
            height: 40px;
        }
        &:hover {
            border-color: #3f7df7;
            background: #f9fbff;
            .ico {
                color: #3f7df7;
            }
        }
    }
    dl {
        display: flex;
        flex-direction: row;
        padding-left: 30px;
        align-items: center;
        height: 91px;
        dd {
            margin-left: 19px;
            h3 {
                font-size: 16px;
                margin-bottom: 9px;
            }
            span{
                font-size: 14px;
                color:#666
            }
            p {
                color: #3f7df7;
                font-size: 12px;
            }
        }
    }
}
.userInfo {
    width: 973px;
    margin: 20px auto 0;
    .name-col{
        display: flex;
        align-items: center;
        span{
            cursor: pointer;
            margin-left: 30px;
            width:20px;
            height: 20px;
        }
        .info-wrap{
            flex:1;
            display: flex;
            justify-content: space-between;
            div{
                display: flex;
                flex:1
            }
            .infoName{
                color: #000;
            }
            p{
                color:#999;
            }
        }
    }
    .clear-realName{
        padding-right: 10px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .clearbtn{
            margin-right: 10px;
        }
        span{
            cursor: pointer;
            color: #1890ff;
        }
    }
    p{
        font-size: 14px;
    }
    .infoName{
        display: flex;
        align-items: center;
        img{
            margin-left: 5px;
        }
    }
    .tip {
        display: flex;
        i {
            font-size: 20px;
            margin-right: 10px;
        }
        width: 100%;
        padding: 10px 17px;
        box-sizing: border-box;
        font-size: 14px;
        color: #333;
    }
    .tip_info{
      border: 1px solid #91D5FF;
      background: #E6F7FF;
      i{
        color: #1890ff;
      }
    }
    .tip_waring{
        border: 1px solid rgb(250, 236, 216);
        background: rgb(253, 246, 236);
        i{
            color: rgb(230, 162, 60);
        }
    }
    .tip_err{
      border: 1px solid #F1A89F;
      background: #FFDED9;
      i{
        color: #ED1C23;
      }
    }
    .row-item {
        padding: 30px 0;
        border-bottom: 1px solid #e4e9f0;
        .opBtn {
            display: block;
            width: 83px;
            height: 27px;
            font-size: 14px;
            color: #fff;
            background: #c1c1c1;
            text-align: center;
            line-height: 27px;
            border-radius: 5px;
            cursor: pointer;
        }
        .cancal{
            background: #c1c1c1;
        }
        .goon{
            cursor: pointer;
            &.goon2{
                color: #1890ff;
            }
        }
    }
}
.masking {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    .maskCnt {
        width: 845px;
        height: 740px;
        overflow: auto;
        padding: 28px 28px 0;
        box-sizing: border-box;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #fff;
        .cntTitle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #dddddd;
            padding-bottom: 22px;
            h3 {
                font-size: 18px;
                color: #333;
            }
            i {
                cursor: pointer;
                color: #999;
            }
        }
        .cntMain {
            li {
                margin-top: 22px;
                display: flex;
                justify-content: center;
                dl {
                    cursor: pointer;
                    box-sizing: border-box;
                    width: 700px;
                    height: 143px;
                    border: 1px solid #d3d3d3;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 22px;
                    dt {
                        font-size: 18px;
                        h4 {
                            color: #333;
                            margin-bottom: 23px;
                        }
                        p {
                            color: #666666;
                        }
                    }
                    &:hover {
                        background: #f9fbff;
                        border-color: #3f7df7;
                    }
                }
            }
            .active{
                dl{
                    background: #f9fbff;
                    border-color: #3f7df7;
                }
            }
        }
    }
    .footer{
        width: 700px;
        margin:10px auto;
        .guide{
            text-align: right;
            font-size: 14px;
            margin-bottom: 10px;
            a{
                cursor: pointer;
                color: #1890ff;
            }
        }
        .agreement{
            a{
                font-size: 14px;
                color: #1890ff;
            }
        }
        .btns{
            margin-top: 18px;
            text-align: center;
            span{
                cursor: pointer;
                display: inline-block;
                width: 123px;
                height: 36px;
                background:#188fff76;
                border-radius: 8px;
                color: #fff;
                line-height: 36px;
                text-align: center;
            }
            .isClick{
                background:#3758FF;
            }
        }
        .attention{
            background: #F8F8F8;
            padding: 22px;
            font-size:12px;
            color: #FFA147;
            margin-bottom: 15px;
            h5{
                font-size: 16px;
                margin-bottom: 12px;
            }
            p{
                display: flex;
                line-height: 1.5;
                b{
                    margin-right: 5px;
                    margin-top: 0;
                }
            }
        }
    }
}
@media screen and (min-width: 1280px) and (max-width: 1600px)  {
    .masking{
        .maskCnt{
            height: 615px;
            overflow: auto;
        }
    }
}
</style>
